



import { Component, Mixins } from 'vue-property-decorator'
import Explanation from '@/components/organisms/study/Explanation.vue'
import Contents3 from '@/views/student/study/Contents3.vue'

@Component({
  components: {
    Explanation,
  },
})
export default class Explanation5 extends Mixins(Contents3) {}
